import HeaderNavigationArea from './HeaderNavigationArea';
export default HeaderNavigationArea;


// WEBPACK FOOTER //
// ./src/components/App/Header/HeaderNavigationArea/index.js